import { render, staticRenderFns } from "./SBtn.vue?vue&type=template&id=17890452&scoped=true"
import script from "./SBtn.vue?vue&type=script&lang=js"
export * from "./SBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17890452",
  null
  
)

export default component.exports